// Fleet photo manifest. Drop vehicle photos into /public/fleet/<slug>/ and list
// their filenames here to power the "View photos" carousel on each vehicle card.
// Slugs mirror the "Chauffeur Fleet Images 2026" folders.
export const FLEET_IMAGES = {
  'audi-a6': [],
  'bmw-5-series': [],
  'bmw-7-series': [],
  'gmc-yukon': [],
  'mercedes-sprinter': [],
  'mercedes-viano': [],
  'scania-bus': [],
  'tesla-model-3': [],
  'tesla-model-y': [],
  'toyota-coaster': [],
  'toyota-hiace': [],
  'yutong-bus': [],
};

// Maps a vehicle name / class label to its fleet-photo folder slug.
export function fleetSlug(name = '') {
  const n = name.toLowerCase();
  if (n.includes('audi') || n.includes('premium sedan')) return 'audi-a6';
  if (n.includes('bmw 7') || n.includes('s-class') || n.includes('s class') || n.includes('first class')) return 'bmw-7-series';
  if (n.includes('bmw 5') || n.includes('executive sedan')) return 'bmw-5-series';
  if (n.includes('yukon') || n.includes('luxury suv') || n.includes('large suv') || n.includes('suburban')) return 'gmc-yukon';
  if (n.includes('viano') || n.includes('executive van')) return 'mercedes-viano';
  if (n.includes('sprinter')) return 'mercedes-sprinter';
  if (n.includes('scania')) return 'scania-bus';
  if (n.includes('model y') || n.includes('compact suv')) return 'tesla-model-y';
  if (n.includes('model 3') || n.includes('tesla')) return 'tesla-model-3';
  if (n.includes('coaster')) return 'toyota-coaster';
  if (n.includes('hiace')) return 'toyota-hiace';
  if (n.includes('higer') || n.includes('yutong')) return 'yutong-bus';
  return null;
}

// Returns the list of photo URLs for a vehicle, falling back to its card image.
export function resolveFleetImages(name, fallback) {
  const slug = fleetSlug(name);
  const list = slug && FLEET_IMAGES[slug] ? FLEET_IMAGES[slug].map((f) => `/fleet/${slug}/${f}`) : [];
  if (list.length) return list;
  return fallback ? [fallback] : [];
}
